
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("@ember-decorators/component/index", function(){ return i("@ember-decorators/component/index");});
d("@ember-decorators/object/index", function(){ return i("@ember-decorators/object/index");});
import "ember-cli-babel/-embroider-implicit-modules.js";
import "@ember-decorators/component/-embroider-implicit-modules.js";
import "@ember-decorators/object/-embroider-implicit-modules.js";
